import { useCurrentCompany } from 'hooks';
import { useMemo } from 'react';
import { useWatch } from 'react-hook-form';
import { calculateJobTotal } from 'utils';

export interface OpenBankingHook {
  icon: string;
  iconStroke: string;
  showOpenBanking: boolean;
}

export default function useOpenBanking(): OpenBankingHook {
  const { company } = useCurrentCompany();

  const [lineItems, deposit] = useWatch({
    name: ['job.job_items', 'job.deposit_value.amount'],
  });

  const total = useMemo(() => {
    const totals = calculateJobTotal(lineItems);
    return totals.totalIncVat;
  }, [lineItems]);

  const icon = useMemo(() => {
    const diff = total - (deposit ?? 0);
    return diff > 1000000 ? 'close' : 'deposit';
  }, [total, deposit]);

  const iconStroke = useMemo(() => {
    const diff = total - (deposit ?? 0);
    return diff > 1000000 ? 'red-200' : 'purple-500';
  }, [total, deposit]);

  const showOpenBanking = useMemo(() => {
    if (!company) return false;
    return !company?.hide_openbanking;
  }, [company]);

  return {
    icon,
    iconStroke,
    showOpenBanking,
  };
}
